import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionHistoryComponent } from './transaction-history.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';



@NgModule({
  declarations: [
    TransactionHistoryComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    ComponentsModule,
    DateDefaultFormatPipe
  ]
})
export class TransactionHistoryModule { }
